module.exports = __webpack_public_path__ + "static/media/calendar.e591f819.svg";